import React from 'react';
import { Link } from 'react-router-dom';
import { NewTabHint } from './NewTabHint';
type Variant = 'primary' | 'secondary' | 'onDark' | 'ghost';
const styles: Record<Variant, string> = {
  primary: 'bg-brand-navy text-white border-2 border-brand-navy hover:bg-[#083a7c] hover:border-[#083a7c]',
  secondary: 'bg-white text-brand-navy border-2 border-brand-navy hover:bg-brand-tan',
  onDark: 'bg-brand-yellow text-[#3d2b00] border-2 border-brand-yellow hover:bg-[#f7d454] hover:border-[#f7d454]',
  ghost: 'bg-transparent text-brand-navy border-2 border-transparent underline underline-offset-4 hover:border-brand-navy hover:no-underline'
};
const shared = 'inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full px-6 py-3 text-center font-display text-[15px] font-semibold leading-snug transition-all duration-150 hover:-translate-y-0.5 active:translate-y-0 sm:text-base';
type CommonProps = {
  variant?: Variant;
  className?: string;
  children: React.ReactNode;
};
export function ButtonLink({
  to,
  variant = 'primary',
  className = '',
  children
}: CommonProps & {
  to: string;
}) {
  return <Link to={to} className={`${shared} ${styles[variant]} ${className}`} data-id="element-441" data-mp="er7e1j5xrq80">
      {children}
    </Link>;
}
export function ButtonExternal({
  href,
  variant = 'primary',
  className = '',
  children
}: CommonProps & {
  href: string;
}) {
  const isMailto = href.startsWith('mailto:');
  return <a href={href} {...isMailto ? {} : {
    target: '_blank',
    rel: 'noopener noreferrer'
  }} className={`${shared} ${styles[variant]} ${className}`} data-id="element-442" data-mp="12m0ol0t25aym">
      {children}
      {isMailto ? null : <NewTabHint data-id="element-443" data-mp="1ccmycee3f79e" />}
    </a>;
}
export function ButtonAnchor({
  href,
  variant = 'primary',
  className = '',
  children
}: CommonProps & {
  href: string;
}) {
  return <a href={href} className={`${shared} ${styles[variant]} ${className}`} data-id="element-444" data-mp="1lf4kytxnu1wx">
      {children}
    </a>;
}